import { z } from "zod";
// Zod 4 kompiliert Objekt-Validatoren per `new Function(...)` und testet diese
// Fähigkeit schon beim KONSTRUIEREN des ersten `z.object` mit einem
// `Function("")`-Probelauf. Unsere CSP erlaubt kein `unsafe-eval`: der Wurf wird
// zwar abgefangen (Zod fällt still auf den Interpreter zurück), Chrome meldet
// den Versuch aber trotzdem als CSP-Verstoß in der Konsole. `jitless`
// überspringt den Probelauf. Nur im Browser — auf dem Server gibt es keine CSP,
// dort bleibt der schnellere JIT-Pfad aktiv.
//
// Jede Schema-Datei importiert dieses Modul als Seiteneffekt an erster Stelle.
// ESM garantiert, dass es vor dem Rumpf des Importeurs ausgewertet wird — nur
// so steht die Konfiguration sicher vor dem ersten `z.object`, egal ob jemand
// den Barrel oder einen Unterpfad direkt importiert.
if (typeof window !== "undefined")
    z.config({ jitless: true });
